export default {
  savedSuccessfully: "Statistik Antworten wurden erfolgreich gespeichert."

}
